import Popper from "popper.js";
import "bootstrap";

import "@fancyapps/fancybox";
import L from "leaflet";

import axios from "axios";

// Import custom components
// import { initShowScroll } from "./parts/initShowScroll";
import { initNavbar } from "./parts/initNavbar";

var map = L.map("map", {
    center: [52.0306522, 8.5294954],
    zoom: 18,
    icon: mapMarker,
    scrollWheelZoom: false,
    zoomControl: false, // removes zoom controls
    dragging: false, // disable dragging
});

var mapMarker = L.icon({
    iconUrl: "/assets/images/contact/map-marker.svg",
    iconSize: [74, 85], // size of the icon
    iconAnchor: [36, 84], // point of the icon which will correspond to marker's location
});

L.tileLayer(
    "https://api.mapbox.com/styles/v1/marvinhenning/cl6djife6005814mmgpu2w4he/tiles/256/{z}/{x}/{y}@2x?access_token=pk.eyJ1IjoibWFydmluaGVubmluZyIsImEiOiJjbDNlYmQ2cnYwMjAyM2tvMjZtcjZzM3lsIn0.dQ7FCbVs40uSi1-EHsOH6w", {
        attribution: '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
    }
).addTo(map);

var container = L.DomUtil.get('map');
if (container != null) {
    container._leaflet_id = null;
}

L.marker([52.03074285108135, 8.529403209686281], {
    icon: mapMarker
}).addTo(map);

class THEMEBAU {
    init() {
        const methods = [
            // "initShowScroll",
            "initNavbar",
        ];

        methods.forEach((method) => {
            if (this[method]) {
                this[method]();
            }
        });

        return this;
    }

    // initShowScroll() {
    //     return initShowScroll.call(this);
    // }

    initNavbar() {
        return initNavbar.call(this);
    }
}
window.Themebau = new THEMEBAU().init();

/**
 * epunks blog article loader
 */
window.axios = axios;

function isScrolledIntoView(elem) {
    var docViewTop = $(window).scrollTop();
    var docViewBottom = docViewTop + $(window).height();

    var elemTop = $(elem).offset().top;
    var elemBottom = elemTop + $(elem).height();

    return elemBottom <= docViewBottom && elemTop >= docViewTop;
}

$(window).on("scroll", function () {
    $(".rainbow-animation").each(function () {
        if (isScrolledIntoView(this) === true) {
            $(this).addClass("rainbow-temporary");
        }
    });
});

// Code for Circle in Button
window.onload = function() {
    // get all buttons by their class name
    var btns = document.getElementsByClassName('btn-with-ball');

    for(var i = 0; i < btns.length; i++) {
        // create a new span element
        var span = document.createElement('span');

        // add the btn-ball class to the span
        span.className = 'btn-ball';

        // add the style to the span
        span.style.transform = 'translateY(0px)';

        // append the span to the current button
        btns[i].appendChild(span);
    }
}


